var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-ant-drawer-footer",style:(_vm.footerStyle)},[_c('a-button',{style:({ marginRight: '8px' }),attrs:{"type":"primary","size":_vm.size},on:{"click":_vm.onSave}},[_vm._v("\n    保存\n  ")]),_vm._v(" "),_c('a-button',{attrs:{"size":_vm.size},on:{"click":_vm.onClose}},[_vm._v("\n    取消\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ff29f10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/packages/Common/DrawerFooter.vue
// module id = null
// module chunks = 